import React, { Component } from "react";
class AceDatingApp extends Component {
  render() {
    return (
      <section className="col-7 nested">
        <div className="text-group">
          <p className="large-paragraph medium-spacer-bottom col-5">
            I have wanted to work on a dating app for a while now but it is a
            saturated market. As part of the queer community myself, I’ve
            noticed that unfortunately, the Asexual community has the least
            accessibility to existing dating apps. I wanted to find out from the
            community itself.{" "}
          </p>
          <p className="reflections col-2">
            Asexual people want love too. But what are they to do with a dating
            pool that is primarily into the hookup culture?
          </p>
        </div>

        <h2 className="large-spacer-top col-5">Project Overview</h2>

        <h3 className="project-subheading medium-spacer-top col-5">
          <strong>
            <span role="img" aria-label="sparkle">
              📱
            </span>{" "}
            The Product
          </strong>{" "}
        </h3>
        <br></br>
        <p className="large-paragraph medium-spacer-bottom col-5">
          <div className="text-group">A dating app made for asexual users</div>
        </p>
        <h3 className="project-subheading medium-spacer-top col-5">
          <strong>
            <span role="img" aria-label="sparkle">
              ⌛
            </span>{" "}
            Project Duration
          </strong>{" "}
        </h3>
        <br></br>
        <p className="large-paragraph medium-spacer-bottom col-5">
          <div className="text-group">December 2022</div>
        </p>
        <h3 className="project-subheading medium-spacer-top col-5">
          <strong>
            <span role="img" aria-label="sparkle">
              ⚠️
            </span>{" "}
            The Problem
          </strong>{" "}
        </h3>
        <br></br>
        <p className="large-paragraph medium-spacer-bottom col-5">
          <div className="text-group">
            How can we provide an environment where singles aren’t pressured
            into physical intimacy
          </div>
        </p>
        <h3 className="project-subheading medium-spacer-top col-5">
          <strong>
            <span role="img" aria-label="sparkle">
              🏆
            </span>{" "}
            The Goal
          </strong>{" "}
        </h3>
        <br></br>
        <p className="large-paragraph medium-spacer-bottom col-5">
          <div className="text-group">
            To conduct research to gauge the need for an asexual dating app in
            current society
          </div>
        </p>
        <h3 className="project-subheading medium-spacer-top col-5">
          <strong>
            <span role="img" aria-label="sparkle">
              ⚙️
            </span>{" "}
            My Role
          </strong>{" "}
        </h3>
        <br></br>
        <p className="large-paragraph medium-spacer-bottom col-5">
          <div className="text-group">
            UX researcher conducting preliminary research for the need of an
            asexual dating app.
          </div>
        </p>
        <h3 className="project-subheading medium-spacer-top col-5">
          <strong>
            <span role="img" aria-label="sparkle">
              ✍️
            </span>{" "}
            Resposibilities
          </strong>{" "}
        </h3>
        <br></br>
        <p className="large-paragraph medium-spacer-bottom col-5">
          <div className="text-group">
            Formulating research questions, conducting user surveys to answer
            research questions, deciding next steps
          </div>
        </p>

        <h2 className="large-spacer-top col-5">Why an ACE dating app?</h2>

        <br></br>
        <div className="text-group">
          <ul className="text-list medium-spacer-bottom col-5">
            <li>
              Asexual individuals may have different relationship and intimacy
              needs and preferences than those who are not asexual. They may
              have a harder time finding suitable partners or navigating the
              dating scene due to a lack of understanding or awareness about
              asexuality within society.
            </li>
            <li>
              To connect with others who share similar values and relationship
              goals. It could also provide a platform for asexual individuals to
              learn more about asexuality and find support and resources within
              the community.
            </li>
            <li>
              To create a more inclusive and supportive environment for asexual
              individuals.
            </li>
          </ul>
        </div>

        <h2 className="large-spacer-top col-5">
          Can someone who doesn’t Identify as ACE use this App?
        </h2>

        <br></br>
        <div className="text-group">
          <ul className="text-list medium-spacer-bottom col-5">
            <li>
              A space for individuals of all sexualities who are looking for
              relationships that are not centered on sexual or romantic
              attraction.
            </li>
            <li>
              Particularly useful for individuals who may not feel comfortable
              or compatible with traditional dating app models that prioritize
              sexual attraction.
            </li>
            <li>
              Create a more inclusive and supportive online dating environment
              for all individuals. By promoting understanding and respect for
              diverse relationship and intimacy needs, the app could contribute
              to a more welcoming and accepting online dating culture.
            </li>
          </ul>
        </div>

        <h1 className="large-spacer-top col-5">Understanding The User</h1>
        <br></br>
        <div className="text-group">
          <p className="large-paragraph medium-spacer-bottom col-5">
            User research was particularly hard as I don’t Peronally know anyone
            who openly identifies as asexual. After reaching out to several
            individuals on Twitter and Finding friends of friends, I was able to
            gather data from 8 individauls about their general thoughts on an
            Asexual Dating App.
          </p>
          <p className="reflections col-2">
            I did not get a chance to talk to these users, in-person or on call,
            so the users are rather anonymous.
          </p>
        </div>

        <h2 className="medium-spacer-top col-5">User Survey</h2>
        <br></br>
        <div className="text-group">
          <p className="large-paragraph medium-spacer-bottom col-5">
            <span>
              <h3 className="project-subheading">Survey Questions</h3>{" "}
            </span>
            <br></br>
            <span>
              <h3>01</h3> Do you identify as asexual?
            </span>
            <br></br>
            <br></br>
            <span>
              <h3>02</h3> What is your opinion on online dating?
            </span>
            <br></br>
            <br></br>
            <span>
              <h3>03</h3> Have you been on dating apps before?
            </span>
            <br></br>
            <br></br>
            <span>
              <h3>04</h3> If so, what are some of the features you dislike the
              most?
            </span>
            <br></br>
            <br></br>
            <span>
              <h3>05</h3> What are some features in dating apps that you would
              like to see?
            </span>
            <br></br>
            <br></br>
            <span>
              <h3>06</h3> Apps like Hinge and Bumble that allow a person to
              showcase their gender and sexuality are great for the LGBTQIA+
              movement. (Agree/Disagree scale question)
            </span>
            <br></br>
            <br></br>
            <span>
              <h3>07</h3> I think existing dating apps are not useful for an
              asexual person.(Agree/Disagree scale question)
            </span>
            <br></br>
            <br></br>
            <span>
              <h3>08</h3> Dating apps are not for me. I don't plan on using any
              dating apps. (Agree/Disagree scale question)
            </span>
          </p>
        </div>

        <div className="text-group">
          <p className="large-paragraph medium-spacer-bottom col-5">
            <span>
              <h3 className="project-subheading">Survey Answers (MCQs)</h3>{" "}
            </span>
            <br></br>
            Here are some statistics on Multiple Choice Questions and Answers
            from Google Forms -
          </p>
        </div>

        <div className="text-group">
          <div className="col-5 medium-spacer-bottom small-spacer-top">
            <img
              className="project-image"
              alt="Signing Up Use Case Diagram"
              src={require("../assets/images/acedatingapp/user_survey_1.png")}
            />
          </div>
        </div>

        <br></br>
        <div className="text-group">
          <div className="col-5 medium-spacer-bottom small-spacer-top">
            <img
              className="project-image"
              alt="Signing Up Use Case Diagram"
              src={require("../assets/images/acedatingapp/user_survey_2.png")}
            />
          </div>
        </div>

        <br></br>
        <div className="text-group">
          <div className="col-5 medium-spacer-bottom small-spacer-top">
            <img
              className="project-image"
              alt="Signing Up Use Case Diagram"
              src={require("../assets/images/acedatingapp/user_survey_3.png")}
            />
          </div>
        </div>

        <br></br>
        <div className="text-group">
          <div className="col-5 medium-spacer-bottom small-spacer-top">
            <img
              className="project-image"
              alt="Signing Up Use Case Diagram"
              src={require("../assets/images/acedatingapp/user_survey_4.png")}
            />
          </div>
        </div>

        <br></br>
        <div className="text-group">
          <div className="col-5 medium-spacer-bottom small-spacer-top">
            <img
              className="project-image"
              alt="Signing Up Use Case Diagram"
              src={require("../assets/images/acedatingapp/user_survey_5.png")}
            />
          </div>
        </div>

        <br></br>
        <div className="text-group">
          <p className="large-paragraph medium-spacer-bottom col-5">
            From this basic survey, we can confirm that there is indeed a need
            for an asexual dating app. Users also gave their detailed opinions
            for questions without multiple choices which led us to answer our
            research questions.
          </p>
          <p className="reflections col-2">
            Here is the complete{" "}
            <a
              className="social-media-link"
              target="blank"
              href="https://github.com/KanupriyaJamwal/Ace-Dating-App/blob/a4ba10ca3098b450077290e75da0361b0a07158e/ACE%20Dating%20App%20Survey%20(Responses).xlsx"
            >
              survey response
            </a>
          </p>
        </div>

        <h1 className="large-spacer-top col-5">Research</h1>

        <br></br>
        <div className="text-group">
          <p className="large-paragraph medium-spacer-bottom col-5">
            The research questions were formulated by me. The answers to these
            research questions were loosely inferred from user survey.
          </p>
          <p className="reflections col-2">
            This was done before I went to UCD and realised how real research is
            done 🧐
          </p>
        </div>

        <h2 className="medium-spacer-top col-5">Research QnA</h2>

        <div className="text-group">
          <p className="large-paragraph medium-spacer-bottom col-5">
            <br></br>
            <span>
              <h3 className="header_inline_left">Q</h3>
              <h3 className="header_inline_right, project-subheading">
                &nbsp;Why is ACE visibility low? Can we create an app to bypass
                that visibility? Is a simple solution like highlighting people’s
                sexuality or orientation enough?
              </h3>
            </span>
            <br></br>
            Asexual visibility may be low for a variety of reasons, including a
            lack of representation in media and popular culture, as well as a
            lack of understanding or awareness of asexuality within society as a
            whole. An asexual dating app could potentially help to increase
            visibility by creating a space specifically for asexual individuals
            to connect and find support. However, it's important to note that
            simply highlighting people's sexuality or orientation may not be
            sufficient to fully address the issue of visibility. It may also be
            helpful to consider ways to educate and raise awareness about
            asexuality to a wider audience.
            <br></br>
            <br></br>
            <span>
              <h3 className="header_inline_left">Q</h3>
              <h3 className="header_inline_right, project-subheading">
                &nbsp;Could an asexual dating App be useful for the general
                crowd, regardless of sexuality?
              </h3>
            </span>
            <br></br>
            An asexual dating app could potentially be useful for individuals of
            all sexualities, as it could provide a space for people who are
            looking for relationships that are not focused on physical intimacy.
            However, it's important to consider the needs and preferences of the
            target audience for the app, which in this case would be asexual
            individuals.
            <br></br>
            <br></br>
            <span>
              <h3 className="header_inline_left">Q</h3>
              <h3 className="header_inline_right, project-subheading">
                &nbsp;What Recommendation Algorithm can be used for this dating
                app?
              </h3>
            </span>
            <br></br>A While it is not publicly known what algorithm the
            existing dating apps use, it would be a good start to experiment
            with and use a combination of these 2 algorithms -{" "}
            <b>collaborative filtering</b>, which involves using the preferences
            and behavior of similar users to make recommendations, and{" "}
            <b>content-based filtering</b>, which involves using the
            characteristics and features of profiles to make recommendations.
            It's important to note that the effectiveness of a recommendation
            algorithm will depend on the quality and quantity of data available,
            as well as the specific goals and needs of the app. Testing and
            fine-tuning the algorithm over time can help to improve its
            performance and accuracy.
            <br></br>
            <br></br>
            <span>
              <h3 className="header_inline_left">Q</h3>
              <h3 className="header_inline_right, project-subheading">
                &nbsp;Since awareness is pretty low, do we need infographics or
                a chart explaining to its users all the different kinds of
                asexual and romantic terms? Or is that too patronizing?
              </h3>
            </span>
            <br></br>
            Providing infographics or other educational materials about
            different asexual and romantic terms could be helpful for users who
            are new to the concept or still exploring their own identity.
            However, it's also important to consider whether this would be
            patronizing or not, as everyone has different learning styles and
            preferences. It might be helpful to include a variety of resources,
            such as articles, blog posts, and videos, and allow users to choose
            which ones they would like to access.
            <br></br>
            <br></br>
            <span>
              <h3 className="header_inline_left">Q</h3>
              <h3 className="header_inline_right, project-subheading">
                &nbsp;How can we provide an environment where singles aren’t
                pressured into physical intimacy?
              </h3>
            </span>
            <br></br>
            To provide an environment where singles are not pressured into
            physical intimacy, it might be helpful to include features or tools
            that allow users to clearly communicate their boundaries and
            preferences. For example, users could have the option to specify
            their relationship goals or preferences in their profile, and the
            app could include features that allow users to have conversations
            about these topics before meeting in person. Additionally, it could
            be helpful to include resources or support for users who may be
            feeling pressure to conform to societal expectations around
            relationships and intimacy.
            <br></br>
          </p>
        </div>

        <h2 className="large-spacer-top col-5">AI Generated Design</h2>

        <div className="text-group">
          <p className="large-paragraph medium-spacer-bottom col-5">
            I asked the Midjourney Research AI to provide me with basic designs
            for an Asexual dating app and this is what the bot generated. -
          </p>
        </div>

        <div className="text-group">
          <div className="medium-spacer-bottom small-spacer-top">
            <img
              className="project-image"
              alt="Signing Up Use Case Diagram"
              src={require("../assets/images/acedatingapp/mai1.png")}
            />
          </div>
        </div>
        <br></br>

        <div className="text-group">
          <div className="medium-spacer-bottom small-spacer-top">
            <img
              className="project-image"
              alt="Signing Up Use Case Diagram"
              src={require("../assets/images/acedatingapp/mai2.png")}
            />
          </div>
        </div>
        <br></br>

        <div className="text-group">
          <div className="medium-spacer-bottom small-spacer-top">
            <img
              className="project-image"
              alt="Signing Up Use Case Diagram"
              src={require("../assets/images/acedatingapp/mai3.png")}
            />
          </div>
        </div>
        <br></br>

        <div className="text-group">
          <div className="medium-spacer-bottom small-spacer-top">
            <img
              className="project-image"
              alt="Signing Up Use Case Diagram"
              src={require("../assets/images/acedatingapp/mai4.png")}
            />
          </div>
        </div>
        <br></br>

        <div className="text-group">
          <div className="medium-spacer-bottom small-spacer-top">
            <img
              className="project-image"
              alt="Signing Up Use Case Diagram"
              src={require("../assets/images/acedatingapp/mai5.png")}
            />
          </div>
        </div>
        <br></br>

        <div className="text-group">
          <div className="medium-spacer-bottom small-spacer-top">
            <img
              className="project-image"
              alt="Signing Up Use Case Diagram"
              src={require("../assets/images/acedatingapp/mai6.png")}
            />
          </div>
        </div>
        <br></br>

        <div className="text-group">
          <div className="medium-spacer-bottom small-spacer-top">
            <img
              className="project-image"
              alt="Signing Up Use Case Diagram"
              src={require("../assets/images/acedatingapp/mai7.png")}
            />
          </div>
        </div>
        <br></br>

        <div className="text-group">
          <div className="medium-spacer-bottom small-spacer-top">
            <img
              className="project-image"
              alt="Signing Up Use Case Diagram"
              src={require("../assets/images/acedatingapp/mai8.png")}
            />
          </div>
        </div>
        <br></br>

        <div className="text-group">
          <div className="medium-spacer-bottom small-spacer-top">
            <img
              className="project-image"
              alt="Signing Up Use Case Diagram"
              src={require("../assets/images/acedatingapp/mai9.png")}
            />
          </div>
        </div>
        <br></br>

        <h1 className="large-spacer-top col-5">Going Forward</h1>
        <br></br>

        <h3 className="project-subheading medium-spacer-top col-5">
          <strong>
            <span role="img" aria-label="sparkle">
              👣
            </span>{" "}
            Next Steps
          </strong>{" "}
        </h3>
        <br></br>
        <div className="text-group">
          <ul className="text-list medium-spacer-bottom col-5">
            <li>
              Create Wireframes and lo-fi prototypes for a home screen, profile
              creation screen, messaging screen, settings screen
            </li>
            <li>Conduct Usability tests and note patterns</li>
            <li>Iterate on designs for better user journey</li>
            <li>Create mockups and a hi-fi prototype</li>
            <li>More usability tests and user interviews</li>
          </ul>
        </div>

        <h3 className="project-subheading medium-spacer-top col-5">
          <strong>
            <span role="img" aria-label="sparkle">
              📘
            </span>{" "}
            Learnings
          </strong>{" "}
        </h3>
        <br></br>
        <div className="text-group">
          <ul className="text-list medium-spacer-bottom col-5">
            <li>
              This was the first Research only project I’ve taken up and I
              realized that any product needs solid research first
            </li>
            <li>
              To create an app like this, user input will be necessary at every
              iteration
            </li>
            <li>
              A product that solves the needs of the group with least
              accessibility ultimately helps all user groups
            </li>
          </ul>
        </div>
      </section>
    );
  }
}

export default AceDatingApp;
